import { useFormik } from "formik";
import TextInput from "../../../../components/inputs/textInput";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/buttons/button";
import UserIcon from "../../../../icons/userIcon";
import PhoneIcon from "../../../../icons/phoneIcon";
import ShipmentDeliveredIcon from "../../../../icons/shipmentDeliveredIcon";
import { useState } from "react";
import MailIcon from "../../../../icons/mailIcon";
import MessagePopup from "../../../../components/popups/messagePopup";

const Settings = () => {
  const [save, setSave] = useState(false);
  const formik = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      setSave(true);
    },
  });

  const { t } = useTranslation();

  const handleCancel = () => {
    formik.resetForm();
  };
  return (
    <main className="relative">
      <h2 className="my-4 text-xl capitalize">{t("accountDetails")}</h2>
      <form onSubmit={formik.handleSubmit}>
        <section className="inputs">
          <TextInput
            icon={<UserIcon />}
            formik={formik}
            label={t("name")}
            name={"name"}
            placeholder={t("enterCustomerName")}
          />
          <TextInput
            icon={<PhoneIcon fill={"#888888"} className="size-6" />}
            formik={formik}
            label={t("phone")}
            name={"phone"}
            placeholder={t("enterPhoneNumber")}
          />
        </section>
        <section className="oneInput">
          <TextInput
            icon={<MailIcon fill={"#888888"} className="size-6" />}
            formik={formik}
            label={t("email")}
            name={"email"}
            placeholder={t("enterEmail")}
          />
        </section>
        <h2 className="my-4 text-xl capitalize">{t("resetPassword")}</h2>
        <section className="inputs">
          <TextInput
            formik={formik}
            label={t("currentPassword")}
            name={"oldPassword"}
            placeholder={t("enterCurrentPassword")}
            type="password"
          />
          <TextInput
            formik={formik}
            label={t("newPassword")}
            name={"newPassword"}
            placeholder={t("enterNewPassword")}
            type="password"
          />
        </section>
        <section className="oneInput">
          <TextInput
            formik={formik}
            label={t("reEnterPassword")}
            name={"rePassword"}
            placeholder={t("reEnterPassword")}
            type="password"
          />
        </section>
        <div className="flex items-center gap-3">
          <Button text={t("saveChanges")} className={"bg-mainRed py-2 my-4"} />
          <Button
            text={t("cancel")}
            type="button"
            onClick={handleCancel}
            className={"bg-white border !border-mainRed !text-mainRed py-2 my-4"}
          />
        </div>
      </form>
      <MessagePopup
        text={t("savedSuccess")}
        icon={<ShipmentDeliveredIcon className="size-20" />}
        state={save}
        setState={setSave}
      />
    </main>
  );
};

export default Settings;
